import { AutoComplete, Badge, Tag } from 'antd';
import Styled from 'styled-components';

const ChatWrapper = Styled.div`
  .create-action{
    padding: 0 25px;
    margin: 25px 0 18px;
    @media only screen and (max-width: 379px){
      padding: 0 20px;
    }
    .btn-add{
      width: 100%;
      height: 44px;
      text-align: center;
      border: 1px solid ${({ theme }) => theme['border-color-light']};
      background: ${({ theme }) => theme['bg-color-light']};
      color: ${({ theme }) => theme['gray-color']};
      svg,
      img,
      i{
        ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 4px;
      }
    }
  }
`;

const ChatTag = Styled(Tag)`
  background-color: ${({ tagColor, opacity = "20" }) => `${tagColor}${opacity}`} !important;
  color: ${({ tagColor }) => tagColor} !important;
  border: 1px solid ${({ tagColor }) => tagColor} !important;
  border-radius: 15px;
  display: flex;
  align-items: center;
  margin-left: 0 !important;
  justify-content: center;
  height: ${({ height = '30px' }) => height};
  font-size: 12px !important;
`;

const ChatHeadingLabel = Styled.h3`
  padding-top: 10px;
`;

const UL = Styled.ul`
  list-style-type: none;
  li {
    display: inline-block;
    padding: 5px;
  }
`;

const Content = Styled.div`
  height: 495px;
  overflow-y: auto;
  overflow-x: hidden;
  ul{
    overflow-x: hidden;
  }
  .chat-link-signle{
    position: relative;
    background: #fff;
    border-radius: 4px;
    width: 100%;
    margin: 0;
    &:before{
      content: '';
      position: absolute;
      width: calc(100% + 20px);
      height: 100%;
      background: #fff;
      right: -10px;
      left: -10px;
      box-shadow: 0 15px 50px ${({ theme }) => theme['light-color']}20;
      border-radius: 4px;
      visibility: hidden;
      opacity: 0;
      transition: 0.3s ease;
      z-index: 1;
    }
    &:hover:before{
      visibility: visible;
      opacity: 1;
    }
    .linkcito{
      display: flex;
      padding: 20px 24px;
      position: relative;
      z-index: 1;
      width: 100%;
      border: none;
      background: none;
    }
    .author-figure{
      ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 15px;
      flex: .1;
      img{
        max-width: 46px;
        border-radius: 50%;
      }
    }
    .author-info{
      ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 6px;
      flex: .76;
      text-align: left;
      .author-name{
        font-weight: 600;
        color: ${({ theme }) => theme['dark-color']};
      }
      .author-chatText{
        color: ${({ theme }) => theme['light-color']};
      }
    }
    .author-chatMeta{
      flex: .16;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      @media (max-width: 991px){
        align-items: center;
        justify-content: center;
      }
      span{
        float: left;
        font-size: 12px;
        color: ${({ theme }) => theme['light-color']};
      }
      .ant-badge{
        margin-top: 8px;
        span{
          color: #fff;
        }
      }
    }
  }
`;

const BlockSpan = Styled.span`
  display: block;
`;

const SingleChatWrapper = Styled.div`
  &.group-chat{
    .chatbox-reply-form{
      input{
        background: #fff !important;
        box-shadow: 0 5px 30px ${({ theme }) => theme['light-color']}15;
      }
    }
  }
  >.ant-card{
    .ant-card-body{
      padding: 25px 0 !important;
    }
  }
  .ant-card-head{
    padding: 0 30px !important;
    box-shadow: 0 10px 20px ${({ theme }) => theme['extra-light-color']}15;
    border: 0 none;
    .ant-card-extra{
      .ant-dropdown-trigger{
        ${({ theme }) => (!theme.rtl ? 'margin-left' : 'margin-right')}: 0 !important;
      }
    }
    .ant-card-head-wrapper {
      .ant-card-head-title {
        overflow: auto;
        white-space: normal;
        font-size: 0.9em;
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 0;
        color: ${({ theme }) => theme['light-color']};
      }
    }
    .ant-card-head-title{
      h1{
        font-weight: 500;
        margin-bottom: 6px;
      }
      p{
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 0;
        color: ${({ theme }) => theme['light-color']};
      }
    }
  }

  .group-chat-header{
    padding: 8px 0;
    align-items: center;
    width: 100%;
    text-align: center;
    @media only screen and (max-width: 479px){
      flex-flow: column;
    }
    h1{
      @media only screen and (max-width: 479px){
        margin-bottom: 15px !important;
      }
    }
    .members{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      a{
        :not(:last-child){
          ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 4px;
        }
      }
      img{
        max-width: 30px;
      }
      .show-more,
      .add-more{
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        span{
          margin: 0;
        }
      }
      .show-more{
        background-color: ${({ theme }) => theme['primary-color']};
        span{
          font-size: 10px;
          font-weight: 500;
          color: #fff;
        }
      }
      .add-more{
        border: 1px dashed ${({ theme }) => theme['border-color-deep']};
        span{
          line-height: .4;
        }
      }
    }
  }

  .atbd-chatbox{
    height: 450px;
    overflow-x: hidden;
    .time-connector{
      position: relative;
      z-index: 10;
      margin: -5px 0 15px;
      &:after{
        position: absolute;
        width: 100%;
        height: 1px;
        ${({ theme }) => (!theme.rtl ? 'left' : 'right')}: 0;
        top: 50%;
        transform: translateY(-50%);
        background-color: ${({ theme }) => theme['border-color-light']};
        content: '';
        z-index: -1;
      }
      span{
        text-transform: capitalize;
        font-size: 13px;
        padding: 0 24px;
        background-color: #fff;
        color: ${({ theme }) => theme['light-color']};
      }
    }
    .atbd-chatbox__single{
      
      .attachment-msg-container {
        display: block;
        font-weight: 900;
        padding: 0;
        .attachment-msg-container__file-icon {
          min-width: 200px;
          border-radius: 5px;
        }
        .attachment-msg-container__image {
          max-width: min(670px, 100%);
          min-width: 200px;
          max-height: 400px;
          min-height: 100px;
          object-fit: cover;
        }
      }
      .atbd-chatbox__content {
        margin: 0;
        white-space: pre-line;
      }
      padding: 0 25px;
      &:not(:last-child){
        margin-bottom: 30px;
      }
      &:last-child{
        padding-bottom: 5px;
      }
      .left{
        max-width: 80%;
        display: flex;
        align-items: flex-start;
        .attachment-msg-container {
          color: ${({ theme }) => theme['gray-color']};
          .attachment-msg-container__file-icon {
            min-width: 200px;;
            background: #00000010;
          }
        }
        .atbd-chatbox__content{
          margin-top: -4px;
        }
        .message-box{
          background: #c0defc;
          color: ${({ theme }) => theme['gray-color']};
        }
        .atbd-chatbox__actions{
          margin: ${({ theme }) => (theme.rtl ? '0 15px 0 0' : '0 0 0 15px')};
        }
      }
      .right{
        max-width: 80%;
        float: ${({ theme }) => (theme.rtl ? 'left' : 'right')};
        .attachment-msg-container {
          color: ${({ theme }) => theme['gray-color']};
        }
        .atbd-chatbox__actions{
          margin: ${({ theme }) => (theme.rtl ? '0 0 0 15px' : '0 15px 0 0')};
        }
        .atbd-chatbox__name{
          text-align: ${({ theme }) => (theme.rtl ? 'left' : 'right')};
        }
        .message-box{
          word-break: break-word;
          ${({ theme }) => (!theme.rtl ? 'border-radius: 15px 15px 0 15px;' : 'border-radius: 15px 15px 15px 0')};
          background: ${({ theme }) => theme['bg-color-deep']};
          color: ${({ theme }) => theme['gray-color']};
        }
        .atbd-chatbox__contentInner{
          justify-content: right;
        }
      }
    }
    .atbd-chatbox__name{
      font-size: 14px;
      font-weight: 600;
      span{
        font-size: 12px;
        font-weight: 400;
        margin-left: 15px;
        color: ${({ theme }) => theme['light-color']};
      }
    }
    .atbd-chatbox__contentInner{
      align-items: center;
      .message-box + .message-box{
        margin-top: 5px;
      }
    }
    .message-seen{
      margin-top: 10px;
      &.text-right{
        text-align: ${({ theme }) => (theme.rtl ? 'left' : 'right')};
      }
      img{
        max-width: 20px;
        border-radius: 50%;
      }
      .message-seen__time{
        font-size: 12px;
        font-weight: 400;
        color: ${({ theme }) => theme['light-color']};
      }
    }
    .group-seen{
      margin-top: 5px;
      text-align: ${({ theme }) => (theme.rtl ? 'left' : 'right')};
      img{
        max-width: 20px;
        &:not(:last-child){
          ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 3px;
        }
      }
    }
    .atbd-chatbox__actions{
      display: flex;
      align-items: center
      ${({ theme }) => (!theme.rtl ? 'margin-left' : 'margin-right')}: 15px;
      @media only screen and (max-width: 767px){
        flex-flow: column;
      }
      .ant-dropdown-trigger{
        line-height: 1;
        color: ${({ theme }) => theme['border-color-deep']};
        .anticon-smile{
          color: ${({ theme }) => theme['extra-light-color']};
        }
        &{
          + .ant-dropdown-trigger{
            ${({ theme }) => (!theme.rtl ? 'margin-left' : 'margin-right')}: 12px;
            @media only screen and (max-width: 767px){
              margin: 10px 0 0;
            }
          }
        }
      }
    }
  }
`;

const MessageList = Styled.div`
  display: block;
  max-width: 670px;
  font-size: 15px;
  ${({ theme }) => (!theme.rtl ? 'border-radius: 0 15px 15px' : 'border-radius: 15px 0 15px 15px')};
  padding: 18px 20px;
  line-height: 1.67;
  color: #fff;
`;

const Footer = Styled.div`
  padding: 0 25px;
  .chatbox-reply-form{
    position: relative;
    margin-top: 20px;
    align-items: center;
    @media only screen and (max-width: 575px){
      flex-flow: column;
    }
    .smile-icon{
      position: relative; 
      position: absolute;
      ${({ theme }) => (!theme.rtl ? 'left' : 'right')}: 25px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      z-index: 99999999;
      @media only screen and (max-width: 575px){
        top: 26px;
      }
      aside{
          position: absolute;
          z-index: 999999999;
          bottom: 0;
          .emoji-search{
            padding: 8px;
            height: auto;
            border-radius: 5px;
          }
      }
      .ant-dropdown-trigger{
        display: flex;
        align-items: center;
      }
      a{
        display: flex;
      }
      svg,
      i{
        color: ${({ theme }) => theme['extra-light-color']};
      }
    }
    &.hasFile{
      .ant-upload-list{
        &.ant-upload-list-text{
          padding: 15px;
        }
      }
      
    }
    .ant-upload-list{
      display: flex;
      margin-top: 0!important;
      /* position: absolute;
      top: -70px; */
      ${({ theme }) => (!theme.rtl ? 'left' : 'right')}: 0;
    }
    .ant-upload  button {
      cursor: pointer;
    }
    .chatbox-reply-input{
      width: 100%;
      ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 8px;
      .ant-form-item {
        margin: 0;
      }

      textarea {
        resize: none;
      } 

      input, textarea {
        padding: 20px 25px;
        height: 70px;
        border: 0 none;
        border-radius: 35px;
        background: ${({ theme }) => theme['bg-color-normal']};
        &::placeholder{
          font-size: 14px;
          color: ${({ theme }) => theme['light-color']};
        }
        &:focus{
          border: 0 none;
          outline: none;
        }
        @media only screen and (max-width: 575px){
          height: 50px;
          margin-bottom: 20px;
        }
      }
    }
    input,
    span{
      ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 8px;
    }
    .chatbox-reply-action{
      align-items: center;
      a{
        span{
          display: block;
        }
      }
      .btn-send{
        box-shadow: 0 8px 13px #5F63F220;
      }
      .ant-upload-select,
      button{
        min-width: 50px;
        height: 50px;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        span{
          ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 0;
          color: #fff;
        }
      }
      .ant-upload-select {
        cursor: pointer;
        background: ${({ theme }) => theme['bg-color-normal']};
        .ant-upload{
          display: flex;
          width: 100%;
          height: 100%;
          justify-content: center;
          align-items: center;
          ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 0;
          svg{
            margin-top: 4px;
            color: ${({ theme }) => theme['light-color']};
          }
        }
      }
      button{
        padding: 0;
      }
    }

    .ant-upload-select-picture-card{
      margin: 0;
      width: 50px;
      border-radius: 50% !important;
      border: 0 none;
      background-color: ${({ theme }) => theme['bg-color-normal']} !important;
    }
    .ant-upload-list{
      &.ant-upload-list-text{
        display: block;
        top: auto;
        bottom: 136px;
        background: #fff;
        padding: 0;
        border-radius: 5px;
        box-shadow: 0 5px 20px #9299B803;
        >div{
          display: block;
        }
        .ant-upload-list-item{
          height: 24px;
          border-radius: 4px;
          background-color: ${({ theme }) => theme['bg-color-normal']};
          button{
            width: auto;
            height: auto;
            min-width: auto;
            background-color: ${({ theme }) => theme['bg-color-normal']};
            svg{
              color: ${({ theme }) => theme['info-color']};
            }
          }
        }
        .ant-upload-list-item-info{
          >span{
            display: flex;
            align-items: center;
          }
          .ant-upload-list-item-name {
            font-size: 13px;
          }
          .anticon,
          .ant-upload-list-item-name {
            color: ${({ theme }) => theme['info-color']};
          }
        }
      }
      &.ant-upload-list-picture-card{
        .ant-upload{
          height: 50px;
          .ant-upload{
            height: auto;
          }
        }
        .ant-upload-list-picture-card-container{
          width: 60px;
          height: 50px;
        }
        .ant-upload-list-item{
          width: 60px;
          height: 50px;
          padding: 3px;
          .ant-upload-list-item-actions{
            .anticon-eye{
              display: none;
            }
            .anticon{
              margin: 0;
            }
          }
          .ant-upload-list-item-card-actions-btn{
            width: 25px;
            height: 25px;
            min-width: 25px;
          }
          .ant-upload-list-item-thumbnail{
            font-size: 11px;
          }
          .ant-upload-list-item-name{
            display: none;
          }
        }
      }
    }
  }
`;

const ChatSidebar = Styled.div`
  min-height: 550px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 5px 20px #9299B803;
  
  .custom-scrollbar{
    >div{
      @media only screen and (max-width: 1800px){
        ${({ theme }) => (theme.rtl ? 'margin-left: 0 !important;' : 'margin-left: auto !important;')}:;
      }
    }
  }
  @media only screen and (max-width: 991px){
    max-width: 370px;
    margin: 0 auto 40px;
  }
  @media only screen and (max-width: 575px){
    min-height: 580px;
  }
  .ant-card-body{
    padding: 28px 0 !important;
  }
  .chatbox-search{
    padding: 0 25px;
    @media only screen and (max-width: 379px){
      padding: 0 20px;
    }
    .ant-select-selection-search{
      width: 100% !important;
    }
  }
  .ant-select-selector{
    height: auto !important;
  }
  .ant-select-single .ant-select-selector .ant-select-selection-search-input{
    border-radius: 23px;
    background: ${({ theme }) => theme['bg-color-normal']};
    border: 0 none;
    input{
      background: ${({ theme }) => theme['bg-color-normal']};
      height: 46px !important;
    }
  }
  nav{
    padding: 0 25px;
    @media only screen and (max-width: 1199px){
      padding: 0 15px;
    }
    ul{
      margin: 0 0 12px 0;
      padding: 30px 0 0 0;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid ${({ theme }) => theme['border-color-light']};
      @media (max-width: 480px){
        flex-direction: column;
      }
      li{
        padding: 0;
        button {
          position: relative;
          display: block;
          border: none;
          padding: 0 0 18px;
          font-weight: 400;
          background: none;
          color: ${({ theme }) => theme['light-color']};
          &:after{
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 1px;
            content: '';
            opacity: 0;
            visibility: hidden;
            background: ${({ theme }) => theme['primary-color']};
            @media only screen and (max-width: 1199px){
              display: none;
            }
          }
          &.active{
            font-weight: 500;
            color: ${({ theme }) => theme['primary-color']};
            &:after{
              opacity: 1;
              visibility: visible;
            }
          }
          .ant-badge{
            ${({ theme }) => (!theme.rtl ? 'margin-left' : 'margin-right')}: 6px;
          }
          @media (max-width: 480px){
            padding-bottom: 10px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
`;
const BackShadowEmoji = Styled.div`
    width: 100%;
    height: 100%;
    background: #11121760;
    position: fixed;
    top: 0;
    ${({ theme }) => (theme.rtl ? 'right' : 'left')}: 0;
    z-index: 9999;
`;

const AttachmentItemContainer = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 3px;
  font-size: 0.9em;
  padding: 10px;

  .remove-attachment {
    position: absolute;
    top: 0;
    right: 0;
    fontSize: 1.2em;
    display: none;
  }
  :hover {
    .remove-attachment {
      display: block;
    }
  }
`;

const AutoCompleteStyled = Styled(AutoComplete)`
    display: block !important;
    .ant-select-selection-placeholder{
        padding: 0 20px !important;
        text-align: ${({ theme }) => (theme.rtl ? 'right' : 'left')};
        ${({ theme }) => (theme.rtl ? 'right' : 'left')}: 2px !important;
    }
    .ant-select-selector{
        display: flex;
        align-items: center;
        height: 37px !important;
        padding: 0 !important;
        border-color: #E3E6EF !important;
        .ant-select-selection-search{
            .ant-input-affix-wrapper{
                padding: 0 20px;
            }
            .ant-input-suffix{
                svg,
                i{
                    color: ${({ theme }) => theme['extra-light-color']};
                }
            }
        }
    }
    .ant-select-selector input{
        height: 33px !important;
        ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 0 !important;
    }
    .ant-select-selection-search{
        ${({ theme }) => (theme.rtl ? 'right' : 'left')}: 20px;
        width: auto !important;
        @media only screen and (max-width: 575px){
            width: 100% !important;
        }
    }
    .ant-select-selection-search textarea.ant-input{
        padding: 12px 20px;
    }
    .ant-input-affix-wrapper{
        padding: 0 20px;
    }
    .ant-input-affix-wrapper input{
        height: 38px !important;
    }
    .ant-input-affix-wrapper .ant-input-suffix .search-btn{
        height: 38px;
        border-radius: ${({ theme }) => (theme.rtl ? '4px 0 0 4px' : '0 4px 4px 0')};
        svg,
        i{
            color: #fff;
        }
    }
`;

const ChatSearchItem = Styled.div`
  padding: 5px;
  border-bottom: 1px solid ${({ theme }) => theme['light-color']};
  display: flex;
  flex-direction: column;
  gap: 5px;
  .author-name {
    font-weight: 600;
    color: ${({ theme }) => theme['dark-color']};
    font-size: 1.1em;
  }
  .chat-message {
    font-size: 1em;
  }
  .item-footer {
    display: flex;
    width: 100%;
    justify-content: space-between;
    .chat-date {
      color: ${({ theme }) => theme['light-color']};
      font-size: 0.8em;
    }
  }
`;

const ChatUpdatesDecoratorContainer = Styled.span`
  background: ${(data) => data.background};
  height: 20px;
  width: 20px;
  border-radius: 50%;
  padding: 0 !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  animation: sonar 2s infinite;
  position: absolute;
  margin-left: calc(100% - 40px);

  .icon {
    color: white !important;
    width: 16px !important;
    height: 16px !important;
  }

  @keyframes sonar {
    0% {
      box-shadow: 0 0 0 0 ${(data) => data.background}AA;
    }
    100% {
      box-shadow: 0 0 0 10px ${(data) => data.background}00;
    }
  }
`;

const TransferBadge = Styled(Badge)`

    color: #ffffff !important;
    input{
      color:#1111
    }
`;



const StatusTable = Styled(Tag)`
  background-color: ${({ tagColor }) => `${tagColor}20`} !important;
  color: ${({ tagColor }) => tagColor} !important;
  border: 1px solid ${({ tagColor }) => tagColor} !important;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 30px;
  padding: 0px 30px;
  margin: 0px;
  font-size: 12px !important;
`;



export {
  ChatWrapper,
  UL,
  Content,
  BlockSpan,
  MessageList,
  Footer,
  ChatSidebar,
  SingleChatWrapper,
  BackShadowEmoji,
  AttachmentItemContainer,
  AutoCompleteStyled,
  ChatSearchItem,
  ChatUpdatesDecoratorContainer,
  ChatTag,
  ChatHeadingLabel,
  TransferBadge, StatusTable
};
